import * as yup from "yup";

export const emissionDownloadValidation = yup.object({
  file: yup.mixed().nullable().required("File is required"),
});
